<bkg-header></bkg-header>
<bkg-loading [isLoading]="loadingData$ | async"></bkg-loading>
<div class="content">
  <router-outlet></router-outlet>
</div>
<bkg-footer
  *ngIf="!app_mode && !client_app_mode"
  [cookiesAccepted]="cookiesAccepted"
></bkg-footer>
<bkg-cookies-advice
  *ngIf="!app_mode && !client_app_mode"
  (acceptReturn)="onAcceptReturn()"
  (rejectReturn)="onRejectReturn()"
></bkg-cookies-advice>
